module.exports = __webpack_public_path__ + "img/placeholder.e443de96.jpg";